import {
  Box,
  Button,
  Flex,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getSenderIDLists } from "../../../API/account/senderId";

import Empty from "../../../components/UI/Empty";
import CreateSenderID from "../../../components/account/SenderIDs/CreateSenderID";
import CustomModal from "../../../components/UI/CustomModal";
import SenderIDListTable from "../../../components/account/SenderIDs/SenderIDListTable";
import Loader from "../../../components/UI/Loader";
import DomainsListTable from "../../../components/account/domains/DomainsListTable";
import CreateDomain from "../../../components/account/domains/CreateDomain";
import VerifyDomain from "../../../components/account/domains/VerifyDomain";
import ConfirmDomainEmail from "../../../components/account/domains/ConfirmDomainEmail";
import { deleteDomain, getDomains } from "../../../API/account/domains";
import { toaster } from "../../../utils/toast";
import { FaBan } from "react-icons/fa";

function Domain() {
  const { isLoading, data } = useQuery(["domainData"], getDomains);

  const toast = useToast();
  const queryClient = useQueryClient();

  const disclosure = useDisclosure();
  const deleteDisclosure = useDisclosure();
  const verifyDisclosure = useDisclosure();
  const [domainUid, setDomainUid] = useState("");
  const [domainName, setDomainName] = useState("");

  const { mutate, isLoading: deleteLoading } = useMutation(deleteDomain, {
    onSuccess(data) {
      const success = { ...data };
      toaster(toast, success);
      queryClient.invalidateQueries(['domainData']);
      deleteDisclosure.onClose && deleteDisclosure.onClose();
      
    },

    onError(data: any) {
      const errors = { ...data };
      toaster(toast, errors);
    },
  });

  const isAdmin = JSON.parse(localStorage.getItem("isAdmin") || "false");
    if (!isAdmin) {
      return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} gap={3}>
          <FaBan size={"200px"} color="#0066FF"/>
          <Text fontWeight={500}>You don't have access to this resource, contact your admin</Text>
        </Box>
      )
    }
  return (
    <Box>
      <Flex>
        <Box>
          <Text fontSize={"20px"} color="grays.9" fontWeight={"700"}>
            Domains
          </Text>
          <Text fontSize={"12px"} color="#7489AA" fontWeight={"500"}>
            You can manage and add domains here
          </Text>
        </Box>

        <Button
          onClick={disclosure.onOpen}
          colorScheme={"primary"}
          ml="auto"
          size={"sm"}
          isDisabled={isLoading}
        >
          Add Domain
        </Button>
      </Flex>

      <Box mt="62px">
        {/* Empty */}
        {!isLoading && data?.length === 0 && (
          <Empty
            // title='You currently don’t have any sender ID added'
            description={<Text as="span">No Domains added yet</Text>}
            buttonText="Add & Verify Domains"
            buttonAction={disclosure.onOpen}
          />
        )}

        {isLoading && <Loader />}

        {!isLoading && data?.length > 0 && (
          <DomainsListTable
            listsData={data}
            verifyOpen={verifyDisclosure.onOpen}
            setDomainUid={setDomainUid}
            deleteOpen={deleteDisclosure.onOpen}
            setDomainName={setDomainName}
          />
        )}
      </Box>

      <CustomModal
        disclosure={disclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Add Domain
          </Text>
        }
      >
        <CreateDomain close={disclosure.onClose} />
      </CustomModal>

      <CustomModal
        disclosure={verifyDisclosure}
        title={
          <Text fontSize={"20px"} color="grays.8" mt="35px" pr="38px">
            Verify Domain
          </Text>
        }
      >
        <Text color={"#7489AA"} fontSize={"12px"} fontWeight={500} my={3}>
          Please enter the email address at the domain you want to verify. 
        </Text>
        <VerifyDomain
          verifyClose={verifyDisclosure.onClose}
          domainUid={domainUid}
        />
      </CustomModal>

      
      
      <CustomModal disclosure={deleteDisclosure}>
        <Box mt="42px" pb="40px" textAlign={"center"} w="full">
          <Text color="grays.8" fontSize={"20px"} fontWeight="bold">
            Delete Domain
          </Text>
          <Text
            mt="5px"
            fontSize={"sm"}
            fontWeight="medium"
            color="grays.12"
            maxW={"360px"}
            mx="auto"
          >
            Are you sure you want to delete "{domainName}" from your list of domains?
          </Text>

          <Button
            w="full"
            isLoading={isLoading}
            onClick={() => {
              mutate({ domainUid });
            }}
            colorScheme={"red"}
            mt="40px"
          >
            Delete domain
          </Button>
        </Box>
      </CustomModal>
    </Box>
  );
}

export default Domain;
